
class WS {
  constructor() {
    console.log("websocket constructor");
    this.sessionId = "";
    this.initializeWS();
    this.SuppressConsoleMessages = false;
    
    this.AllMessages = [];
    this.FunctionListeners = [];
    this.ConnectionListeners = [];
    this.OutboundMessageQueue = [];
    
    this.AddListener = (listener) => {
      this.FunctionListeners.push(listener);
    }

    this.RemoveListener = (listener) => {
      this.FunctionListeners.splice(this.FunctionListeners.indexOf(listener), 1 );
    }

    this.AddDisconnectListener = (listener) => {
      this.ConnectionListeners.push(listener);
    }

    this.RemoveDisconnectListener = (listener) => {
      this.ConnectionListeners.splice(this.ConnectionListeners.indexOf(listener), 1 );
    }

    this.Send = (data) => {
      if (typeof data === "object") {
        data.sessionId = this.sessionId;

        if(!data.id.toLowerCase().includes('ping'))
        {
          if(!data.id.toLowerCase().includes('pong'))
            {
              this.WriteToConsole("Trying To Send a Message: " , data);   
            }
        }
        

        if (data.payload && typeof data.payload === "object") {    
          data.payload = JSON.stringify(data.payload);
        }
        
        data = JSON.stringify(data);
      }
      if (this.WebSocket.readyState === 1) {
        //this.WriteToConsole("sending data from websocket");
        this.WebSocket.send(data);
      }else{
        this.OutboundMessageQueue.push(data);
      }
    }

    this.Close = () => {
      this.WebSocket.close();
    }
  }

  WriteToConsole = (message) => {
    if(this.SuppressConsoleMessages === false){
      console.log(message);
    }
  }

  WriteToConsole = (message, data) => {
    if(this.SuppressConsoleMessages === false){
      console.log(message, data);
    }
  }

  

  initializeWS = () => {
    
    const query =  new URLSearchParams(window.location.search);
    //this.sessionId = query.get('sessionid');

    //this.WriteToConsole("Initialize WebSocket => My SessionID: " + query.get('sessionid'));

    const server = 'gaming.innovationworks.com';
    const server2 ="192.168.50.134";
    const server3 ="127.0.0.1";
    const server4 ="10.1.10.100";
    const server5 ="10.1.10.112";
    const server6 ="192.168.50.114";
    const server9 ="192.168.50.107";
    const railserver = 'ford-gaming-server.up.railway.app';

    const host = window.location.hostname.includes(server) ? server : 'localhost';    
    const protocol = window.location.protocol.includes('https') ? 'wss:' : 'ws:';
    const port = window.location.hostname.includes(server) ? ':49022' : ':49022'; //Online server | Local Server

    const url = protocol + '//' + server + port;
    //const url = protocol + '//' + railserver;
    
    this.WriteToConsole("URL:" + url);

    this.WebSocket = new WebSocket(url);
    this.WebSocket.onopen = () => {  
      console.log("websocket open");
      this.OutboundMessageQueue.forEach(message => {
        this.Send(message);

      });
      this.OutboundMessageQueue = [];
    }

    this.WebSocket.onclose = () => {
      console.log("websocket close");
      this.ConnectionListeners.forEach(element => {
        element();
      })

      setTimeout(this.initializeWS, 1000);
    }

    this.WebSocket.onmessage = (m) => {
      this.AllMessages.push(m.data);
      if (this.AllMessages.length > 30)
        this.AllMessages = this.AllMessages.slice(this.AllMessages.length - 30, this.AllMessages.length);
      console.log(`Checking message: ${m.data}`); 
      var msg = JSON.parse(m.data);
      console.log(`msg :`,  msg);
      var payload = msg.payload ? JSON.parse(msg.payload) : null;

      if(this.sessionId === `` && (msg.id === 'phoneClientServerResponse' || msg.id === 'phoneClientReconnectServerResponse')){
        console.log('setting id', msg)
          this.sessionId = msg.sessionId;
      }

      console.log(`I have recieved a message, and is it for me ${this.sessionId === msg.sessionId}, here is my this.sessionId ${this.sessionId}, and here is the msg.sessionID ${msg.sessionId}`);
      if (msg !== null && this.sessionId === msg.sessionId) {
        this.FunctionListeners.forEach(element => {
          element(msg.id, payload, msg.userContext, this.sessionId);
        })
      }
    }
  }
}



const websocket = new WS();

export default websocket;
